import { NgModule, Type } from '@angular/core';
import { Route, RouteReuseStrategy, RouterModule, Routes } from '@angular/router';
import { StateService } from '@services/state.service';
import { CustomersComponent } from './customers/customers/customers.component';
import { NewCustomerComponent } from './customers/new-customer/new-customer.component';
import { TemplateFilesListComponent } from './document-editor/template-files-list/template-files-list.component';
import { EmptyComponent } from './empty/empty.component';
import { CanDeactivateEditOrders } from './montage-orders/can-deactivate-edit-orders';
import { EditOrdersComponent } from './montage-orders/edit-orders/edit-orders.component';
import { OpenOrdersComponent } from './montage-orders/open-orders/open-orders.component';
import { PrintReceiptsDialogComponent } from './montage-orders/print-receipts-dialog/print-receipts-dialog.component';
import { OnlyAdminCanUse } from './only-admin-can-use';
import { PartnersComponent } from './partners/partners/partners.component';
import { TeamPlanComponent } from './teams/team-plan/team-plan.component';
import { TeamComponent } from './teams/team/team.component';
import { TeamsComponent } from './teams/teams/teams.component';
import { WhenStateKnown } from './when-state-known';
import { OrderTrashComponent } from './trash/order-trash/order-trash.component';
import { MyReuseStrategy } from './my.reuse.strategy';
import { TestViewComponent } from './test-gui/test-view/test-view.component';

export const Paths: any = {
  ORDERS_ALL: 'orders',
  ORDERS_ASSIGNED: 'orders/assigned',
  ORDERS_CANCELLED: 'orders/cancelled',
  ORDERS_COMPLETE: 'orders/complete',
  ORDERS_OPEN: 'orders/open',
  ORDERS_BILLED: 'orders/billed',
};

function adminRoute<T>(path: string, c: Type<T>): Route {
  return {
    path,
    component: c,
    canActivate: [WhenStateKnown, OnlyAdminCanUse]
  };
}

function commonRoute<T>(path: string, c: Type<T>): Route {
  return {
    path,
    component: c,
    canActivate: [WhenStateKnown]
  };
}

const routes: Routes = [
  adminRoute('templates', TemplateFilesListComponent),
  adminRoute(Paths.ORDERS_ASSIGNED, OpenOrdersComponent),
  commonRoute(Paths.ORDERS_OPEN, OpenOrdersComponent),
  commonRoute(Paths.ORDERS_COMPLETE, OpenOrdersComponent),
  adminRoute(Paths.ORDERS_CANCELLED, OpenOrdersComponent),
  adminRoute(Paths.ORDERS_BILLED, OpenOrdersComponent),
  commonRoute('orders', OpenOrdersComponent),
  {
    path: 'orders/:id',
    component: EditOrdersComponent,
    canActivate: [WhenStateKnown],
    canDeactivate: [CanDeactivateEditOrders]
  },
  adminRoute('customers/:id', NewCustomerComponent),
  adminRoute('customers', CustomersComponent),
  adminRoute('partners', PartnersComponent),
  adminRoute('receipt-print', PrintReceiptsDialogComponent),
  commonRoute('date/:id', TeamPlanComponent),
  adminRoute('teams/:id', TeamComponent),
  adminRoute('teams', TeamsComponent),
  adminRoute('trash/orders', OrderTrashComponent),
  adminRoute('trash/documents', OrderTrashComponent),
  commonRoute('test', TestViewComponent),
  { path: '', component: EmptyComponent, pathMatch: 'full' },
  { path: '**', component: EmptyComponent },
  //
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
      { useHash: true }
    )],
  providers: [
    CanDeactivateEditOrders,
    OnlyAdminCanUse,
    StateService,
    WhenStateKnown,
    //{provide: RouteReuseStrategy, useClass: MyReuseStrategy}
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
